import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Card, Heading } from "@icg360/design-system";

import { trackEvent } from "utils";

import styles from "./featured-offers-shingle-reseal.module.scss";

export const FeaturedOfferShingleReseal = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent("Featured Offer Shown", {
      offerInternalName: "wind-defense",
    });
  }, []);

  return (
    <Card className={styles.cardDS}>
      <div className={styles.title}>
        <Heading size="md">Property services</Heading>
      </div>
      <div className={styles.content}>
        <Heading size="xs" className={styles.heroTextDS}>
          <span className={styles.highlightText}>Storm Protection&nbsp;</span>|
          Wind Defense
        </Heading>
        <Heading size="lg" className={styles.heroTextDS}>
          Sign up for a chance to{" "}
          <span className={styles.highlightText}>strengthen your roof</span>{" "}
          ahead of the next hurricane
        </Heading>
        <Button
          onPress={() =>
            navigate(`/my/property-services/wind-defense`, {
              state: { from: "/my/overview" },
            })
          }
          data-testid="get-started-btn"
          className={styles.getStartedButtonDS}
        >
          Get started
        </Button>
      </div>
    </Card>
  );
};
